import React, { useContext, useState } from 'react'
import { errorToast, successToast } from '../../../utils/notificationUtils'
import SettingHandler from '../../../Apihander/setting/settingHandler'
import { useForm } from 'react-hook-form'
import '../../../css/login.css'
import '../../../css/accountSetting.css'

const SettingPassword = () => {
  const [loading, setLoading] = useState('')
  const { register, handleSubmit, formState: { errors }, watch, reset } = useForm();

  const onsubmit = async (payload) => {
    // console.log(payload, 'changepassword payload')
    try {
      setLoading(true)

      const data = await SettingHandler.doHandlerChangePassword(payload)
      if (data.statusCode === 200) {
        successToast(data?.message)
        setLoading(false)
        reset()
      } else {
        const errorMessage =
          data?.response?.data?.message || data?.message || "An error occurred";
        errorToast(errorMessage)
        setLoading(false)
      }

    } catch (error) {
      console.log('Error on Contact :', error)
      const errorMessage =
        error?.response?.data?.message || error.message || "An error occurred";
      errorToast(errorMessage);
      setLoading(false)

    }
  }
  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Change password
      </h2>
      <form className='vr-set-card' onSubmit={handleSubmit(onsubmit)}
        noValidate
      >
        <div className="vr-set-form">
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="oldPassword">Current password</label>
            <input type="password" id="oldPassword" name="oldPassword" placeholder="Enter your current password"
              className={`vr-input vr-set-input ${errors.oldPassword ? 'is-error' : ''}`}
              {...register("oldPassword", {
                required: 'Enter your current password',
                minLength: {
                  value: 6,
                  message: 'Password must be between 6 and 12 characters',
                },
                maxLength: {
                  value: 12,
                  message: 'Password must be between 6 and 12 characters',
                },
              })} />
            {errors.oldPassword && <span className="error-message vr-set-error">{errors.oldPassword.message}</span>}
          </div>
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="newPassword">New password</label>
            <input type="password" id="newPassword" name="newPassword" placeholder="Enter your new password"
              // className="form-control input-field"
              className={`vr-input vr-set-input ${errors.newPassword ? 'is-error' : ''}`}

              {...register("newPassword", {
                required: 'Enter your new password',
                minLength: {
                  value: 6,
                  message: 'Password must be between 6 and 12 characters',
                },
                maxLength: {
                  value: 12,
                  message: 'Password must be between 6 and 12 characters',
                },
                validate: (value) => {
                  if (value === watch('oldPassword')) {
                    return 'New password cannot be the same as the old password';
                  }
                  return true;
                },
              })}
            />
            {errors.newPassword && <span className="error-message vr-set-error">{errors.newPassword.message}</span>}
          </div>
          <div className="form-group vr-set-field">
            <label className="vr-set-label" htmlFor="confirmPassword">Confirm password</label>
            <input type="password" id="confirmPassword" name="confirmPassword" placeholder="Re-enter your new password"
              // className="form-control input-field"
              className={`vr-input vr-set-input ${errors.confirmPassword ? 'is-error' : ''}`}

              {...register("confirmPassword", {
                required: 'Re-enter your new password',
                minLength: {
                  value: 6,
                  message: 'Password must be between 6 and 12 characters',
                },
                maxLength: {
                  value: 12,
                  message: 'Password must be between 6 and 12 characters',
                },
                validate: (value) => {
                  if (value !== watch('newPassword')) {
                    return 'Passwords do not match with new password';
                  }
                  return true;
                },
              })}
            />
            {errors.confirmPassword && <span className="error-message vr-set-error">{errors.confirmPassword.message}</span>}
          </div>

        </div>

        <div className="vr-set-actions">
          <div className="form-group">
            <button type='submit'
              className='vr-btn vr-btn-primary vr-btn-lg'
              style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
              disabled={loading}>
              {loading ? (
                <>
                  <div
                    className="spinner-border vr-set-spin"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </>
              ) : (
                <span>Save password</span>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default SettingPassword
